import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import {  Pagination, PaginationItem, Stack } from '@mui/material';
import { Redirect } from 'react-router';
import MuiPagination from '@mui/material/Pagination';
import { TablePaginationProps } from '@mui/material/TablePagination';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';

import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, CardActions, Modal, Box, Divider, Select, InputLabel, Backdrop, CircularProgress, Dialog, DialogTitle, DialogActions, Autocomplete } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
// import Customers from './Customers';
import NeighbourhoodHeader from './NeighbourhoodHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams ,gridPageCountSelector, GridPagination, useGridApiContext, useGridSelector} from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import debounce from 'lodash.debounce';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchyIds: any;
        selectedHierarchies: any;
    };
}

export interface IState {
    customer_id: string;
    pageSize: number;
    currentPage: number;
    anchorEl: any;
    customers: any[];
    showAddCustomer: boolean;
    showAddBulkCustomer: boolean;
    customer_name: string;
    mobile: string;
    email: string;
    city_id: string;
    customer_address: string;
    community_id: any;
    mrf: string;
    billing_amount: number;
    routes: any[];
    filter: any;
    type: any;
    filter_community: any;
    hierarchies: any;
    rowCount: any;
    selectedCustomerDetails: any;
    showLoader: boolean;
    newCustomers: any;
    showDeleteDialogue: boolean;
    deleteCustomerId: any;
    customersTotalCount: string;
    customersActiveCount: string;
    customersInactiveCount: string;
}
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
    return (
        <Pagination
            count={count}
            page={page}
            onChange={onChange}
            color="primary"
            shape="rounded"
            variant="outlined"
            showFirstButton
            showLastButton
        
        
        
        />
    );
}
class CustomersList extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            customer_id: this.props.match.params.id,
            pageSize: 10,
            anchorEl: null,
            customers: [],
            showAddCustomer: false,
            showAddBulkCustomer: false,
            customer_name: '',
            currentPage: 0, 
            mobile: '',
            email: '',
            city_id: '',
            customer_address: '',
            community_id: '',
            mrf: '',
            billing_amount: 0,
            routes: [],
            filter: '',
            type: 'all',
            // type: 'community',
            filter_community: '',
            hierarchies: [],
            rowCount: 0,
            selectedCustomerDetails: {},
            showLoader: false,
            newCustomers: [],
            showDeleteDialogue: false,
            deleteCustomerId: '',
            customersTotalCount: '0',
            customersActiveCount: '0',
            customersInactiveCount: '0'
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        this.fetchAccessibleHierarchiesList();
        this.fetchRoutes();
        this.fetchCustomerStats();
        this.fetchAllCustomers();
    }

    public fetchAccessibleHierarchiesList() {
        axios.get(`accessibleHierarchiesList`).then(response => {
            let hierarchies: any = [];
            if (response.data.success) {
                const selectedHierarchyIds = this.props.user.selectedHierarchyIds || [];
                response.data.data.map((hierarchy: any) => {
                    if (selectedHierarchyIds.includes(hierarchy.id)) {
                        hierarchies[hierarchy.id] = hierarchy;
                    }
                });
            }
            this.setState({ hierarchies: hierarchies });
        })
    }

    public fetchRoutes(hierarchies: any[] = this.props.user.selectedHierarchyIds) {
        axios.get(`allCommunitiesLite`, {
            params: { hierarchies },
        }).then((response) => {
            let data: any = response.data.data;
            // let routes: any = [];
            // data.map((route: any) => {
            //     routes[route.id] = {
            //         id: route.id,
            //         route: route.name,
            //         hierarchy_id: route.hierarchy_id,
            //         hierarchy_name: route.hierarchy_name,
            //     };
            // });
            this.setState({ routes: data });
        });
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchAllCustomers(page, limit);
    }, 800);
    // handlePageChange = (page:number) => {
    //     this.setState({ currentPage: page }, () => this.fetchAllCustomers(page));
    // }

    public fetchAllCustomers = (page: any = 0, limit: any = this.state.pageSize) => {
        this.setState({ showLoader: true,currentPage: page });
        let data = {
            "hierarchies": this.props.user.selectedHierarchyIds,
            "community_id": this.state.filter_community ? this.state.filter_community.id : null,
            "filter": this.state.filter,
            "limit": limit,
            "page": page + 1,
            "type": this.state.type,
        }
        axios.post('allCustomers', data, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            if (response.data.success) {
                this.setState({ showLoader: false });
                let list = response.data.data.data;
                let listArr = list.map((el: any) => {
                    let communityId: any = '';
                    let commName: any = '';
                    if (el.community) {
                        communityId = el.community.community_id;
                        // console.log('communityId', communityId);
                        let filteredroute = this.state.routes.filter((el: any) => el.id == communityId);
                        // console.log("filteredroute", filteredroute);
                        commName = filteredroute[0]?.name;
                        // console.log('commName', commName);
                    }
                    return {
                        "id": el.id,
                        "name": el.name,
                        "phone": el.phone,
                        "email": el.email,
                        "bags_left": el.bags_left,
                        "address": el.customer?.location,
                        "community": commName,
                        "status": el.is_active == 1 ? 'Active' : 'Inactive',
                    }
                })
                this.setState({ customers: [...listArr], rowCount: response.data.data.total })
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public fetchCustomerStats() {
        if (this.props.user.selectedHierarchyIds.length) {
            axios.get(`customerActiveStatus`, { params: { "hierarchies": this.props.user.selectedHierarchyIds } }).then(response => {
                let data: any = response.data.data;
                this.setState({
                    customersTotalCount: parseInt((data.active + data.inactive).toString()).toLocaleString(),
                    customersActiveCount: parseInt(data.active.toString()).toLocaleString(),
                    customersInactiveCount: parseInt(data.inactive.toString()).toLocaleString()
                });
            });
        }
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);
        // const totalPages = Math.ceil(this.state.rowCount / this.state.pageSize);

        const handleAddCustomer = (() => {
            this.setState({ showLoader: true });
            let data = {
                name: this.state.customer_name,
                phone: this.state.mobile,
                email: this.state.email,
                community_id: this.state.community_id,
                hierarchies: [this.state.city_id],
                location: this.state.customer_address,
            };
            axios.post(`addCustomer`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                if (response.data.success) {
                    this.setState({ showAddCustomer: false, customer_name: "", mobile: "", email: "", city_id: "", customer_address: "", community_id: "", mrf: "", billing_amount: 0, showLoader: false });
                    toast.success(t("CustomerAddedSuccessfully"), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchAllCustomers();
                } else {
                    this.setState({ showAddCustomer: false, customer_name: "", mobile: "", email: "", city_id: "", customer_address: "", community_id: "", mrf: "", billing_amount: 0, showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showAddCustomer: false, customer_name: "", mobile: "", email: "", city_id: "", customer_address: "", community_id: "", mrf: "", billing_amount: 0, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
            this.fetchRoutes();
        });

        const handleUpdate = (customer_id: any) => {
            this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds };
            axios.get(`getCustomerDetails/` + customer_id, { params: options }).then((response: any) => {
                this.setState({ showLoader: false });
                let customer: any = response.data.data;
                this.setState({
                    showAddCustomer: true,
                    customer_id: customer.id,
                    customer_name: customer.name,
                    mobile: customer.phone,
                    email: customer.email,
                    city_id: customer.hierarchy_id ? customer.hierarchy_id : "",
                    customer_address: (customer.extra) ? customer.extra.location : "",
                    community_id: (customer.community) ? customer.community.community_id : "",
                    mrf: (customer.extra) ? customer.extra.about : "",
                    billing_amount: (customer.extra) ? customer.extra.billing_amount : 0,
                    selectedCustomerDetails: {
                        customer_id: customer.id,
                        customer_name: customer.name,
                        mobile: customer.phone,
                        email: customer.email,
                        city_id: customer.hierarchy_id ? customer.hierarchy_id : "",
                        customer_address: (customer.extra) ? customer.extra.location : "",
                        community_id: (customer.community) ? customer.community.community_id : "",
                    }
                });
            }).catch((error) => {
                this.setState({
                    showLoader: false
                });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        // const handleDeleteCustomer = (customer_id: any) => {
        //     this.setState({showLoader: true});
        //     let data = {
        //         'customer_id': customer_id,
        //         "hierarchies": this.props.user.selectedHierarchyIds
        //     }
        //     axios.post("deleteCustomer", data, { headers: { 'Content-Type': 'application/json' } }).then((response) => {
        //         this.setState({showLoader: false, showDeleteDialogue: false});
        //         this.fetchAllCustomers();
        //     }).catch((error) => {
        //         this.setState({
        //             showLoader: false
        //         });
        //         toast.error(error.response.data.message, {
        //             position: "top-right",
        //             autoClose: 3000,
        //             hideProgressBar: true,
        //             closeOnClick: true,
        //             pauseOnHover: true,
        //             draggable: true,
        //             progress: undefined,
        //             theme: "colored"
        //         });
        //     });
        // }

        const toggleCustomerStatus = (customerId: any, status: string, route_id: any, id: any) => {
            this.setState({ showLoader: true });
            let options = { "customer_id": customerId, "community_id": route_id, "community_user_id": id };
            axios.post(`toggleCustomerStatus`, options).then((response: any) => {
                this.setState({ showLoader: false, anchorEl: null });
                toast.success(t("Customer") + ((status == 'Active') ? ' Deactivated ' : ' Activated ') + t("Successfully"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchAllCustomers();
            }).catch((error) => {
                this.setState({
                    showLoader: false
                });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleEditCustomer = (() => {
            this.setState({ showLoader: true });
            let data: any = {
                // hierarchies: this.props.user.selectedHierarchyIds,
                customer_id: this.state.customer_id,
                name: this.state.customer_name,
                // phone: this.state.mobile,
                // email: this.state.email,
                location: this.state.customer_address,
                // community_id: this.state.community_id,
            };

            axios.post(`editCustomer`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showAddCustomer: false, customer_id: "", customer_name: "", mobile: "", email: "", city_id: "", customer_address: "", community_id: "", mrf: "", billing_amount: 0, showLoader: false });
                if (response.data.success) {
                    toast.success(t("Customer Updated Successfully"), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    console.log("fetchallCustomers");
                    this.fetchAllCustomers();
                } else {
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showAddCustomer: false, customer_id: "", customer_name: "", mobile: "", email: "", city_id: "", customer_address: "", community_id: "", mrf: "", billing_amount: 0, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        // const handleAddBulkCustomer = (() => {
        //     this.setState({ showLoader: true });
        //     let data = {
        //         data: this.state.newCustomers,
        //         // community_id: this.state.community_id,
        //     };
        //     axios.post(`bulkRegistration`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
        //         this.setState({ showAddBulkCustomer: false, newCustomers: [], showLoader: false });
        //         if (response.data.success) {
        //             toast.success(t("CustomersAddedSuccessfully"), {
        //                 position: "top-right",
        //                 autoClose: 3000,
        //                 hideProgressBar: true,
        //                 closeOnClick: true,
        //                 pauseOnHover: true,
        //                 draggable: true,
        //                 progress: undefined,
        //                 theme: "colored"
        //             });
        //             this.fetchAllCustomers();
        //         } else {
        //             toast.error(response.data.msg, {
        //                 position: "top-right",
        //                 autoClose: 3000,
        //                 hideProgressBar: true,
        //                 closeOnClick: true,
        //                 pauseOnHover: true,
        //                 draggable: true,
        //                 progress: undefined,
        //                 theme: "colored"
        //             });
        //             let errors = response.data.errors;
        //             for (var error in errors) {
        //                 toast.error(errors[error][0], {
        //                     position: "top-right",
        //                     autoClose: 3000,
        //                     hideProgressBar: true,
        //                     closeOnClick: true,
        //                     pauseOnHover: true,
        //                     draggable: true,
        //                     progress: undefined,
        //                     theme: "colored"
        //                 });
        //             }
        //         }
        //     }).catch((error) => {
        //         this.setState({ showAddBulkCustomer: false, newCustomers: [], showLoader: false });
        //         toast.error(error.response.data.msg, {
        //             position: "top-right",
        //             autoClose: 3000,
        //             hideProgressBar: true,
        //             closeOnClick: true,
        //             pauseOnHover: true,
        //             draggable: true,
        //             progress: undefined,
        //             theme: "colored"
        //         });
        //     });
        //     this.fetchRoutes();
        // });
      
        const handleAddBulkCustomer = (() => {
            this.setState({ showLoader: true });
            let data = {
                data: this.state.newCustomers,
                // community_id: this.state.community_id,
            };
            axios.post(`bulkRegistration`, data, { headers: { 'Content-Type': 'application/json' } })
                .then((response: any) => {
                    this.setState({ showAddBulkCustomer: false, newCustomers: [], showLoader: false });
                    
                    if (response.data.success) {
                        toast.success(t("CustomersAddedSuccessfully"), {
                            position: "top-right",
                            autoClose: false,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                        this.fetchAllCustomers();
                    } else {
                        let msg = response.data.msg;
                        
                       
                        if (msg) {
                            toast.error(msg, {
                                position: "top-right",
                                autoClose: false,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "colored"
                            });
                        } else {
                            toast.error(t("An unexpected error occurred. Please try again."), {
                                position: "top-right",
                                autoClose: false,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "colored"
                            });
                        }
                        
                        let errors = response.data.errors;
                        for (var error in errors) {
                            toast.error(errors[error], {
                                position: "top-right",
                                autoClose: false,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "colored"
                            });
                        }
                    }
                })
                .catch((error) => {
                    this.setState({ showAddBulkCustomer: false, newCustomers: [], showLoader: false });
                    
                    let msg = error.response?.data?.msg;
                    if (!msg) {
                        msg = error.response?.data?.message;
                    }
                    if (!msg) {
                        msg = "An unexpected error occurred. Please try again.";
                    }
                    
                    toast.error(msg, {
                        position: "top-right",
                        autoClose: false,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                });
            this.fetchRoutes();
        });
        
        const parseCSV = (text: string): string[] => {
            const csvExp = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|"([^""]*(?:"[\S\s][^""]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;

            const values: string[] = [];

            text.replace(csvExp, (m0, m1, m2, m3, m4) => {
                if (m1 !== undefined) {
                    values.push(m1.replace(/\\'/g, "'"));
                } else if (m2 !== undefined) {
                    values.push(m2.replace(/\\"/g, '"'));
                } else if (m3 !== undefined) {
                    values.push(m3.replace(/""/g, '"'));
                } else if (m4 !== undefined) {
                    values.push(m4);
                }
                return '';
            });

            if (/,\s*$/.test(text)) {
                values.push('');
            }

            return values;
        };

        // const handleFileChange = ((file: any) => {
        //     const reader = new FileReader();

        //     reader.onload = (e: ProgressEvent<FileReader>) => {
        //         const contents = e.target?.result as string;
        //         const lines = contents.split(/\r\n|\n/);
        //         const headers = lines[0].split(",");
        //         const result: string[][] = [headers];

        //         for (let i = 1; i < lines.length; i++) {
        //             const currentline = parseCSV(lines[i]);
        //             result.push(currentline);
        //         }

        //         this.setState({ newCustomers: result });
        //     };

        //     reader.readAsText(file);
        // });
        
        const handleFileChange = ((file: any) => {
            const reader = new FileReader();
        
            reader.onload = (e: ProgressEvent<FileReader>) => {
                const contents = e.target?.result as string;
                const lines = contents.split(/\r\n|\n/);
                const headers = lines[0].split(",");
                const result: string[][] = [headers];
        
                for (let i = 1; i < lines.length; i++) {
                    const currentline = parseCSV(lines[i]);
                    
                    if (currentline.some(value => value.trim() !== "")) {
                        result.push(currentline);
                    }
                }
        
                this.setState({ newCustomers: result });
            };
        
            reader.readAsText(file);
        });

        const renderMaskedCell = (params: GridCellParams) => (
            <Box
                component="span"
                sx={isUatEnvironment ? {
                    filter: 'blur(4px)',
                    opacity: 0.5,
                    userSelect: 'none',
                } : undefined}
            >
                {params.value}
            </Box>
        );
        
        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 80
            },
            {
                headerName: "Customer Name",
                field: "name",
                width: 250,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Mobile",
                field: "phone",
                width: 120,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Email",
                field: "email",
                width: 180,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Bags Left",
                field: "bags_left",
                width: 100
            },
            {
                headerName: "Address",
                field: "address",
                width: 200,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Community",
                field: "community",
                width: 180,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Status",
                field: "status",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.status == 'Active') ? 'statusTextSuccess' : 'statusTextError'} style={{ cursor: 'pointer' }}>{params.row.status}</Typography>
                )
            },
            {
                headerName: "Actions",
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        // icon={<FileCopyIcon />}    
                        label="Edit Customer Details"
                        onClick={() => handleUpdate(params.id)}
                        showInMenu
                    />,
                    // <GridActionsCellItem
                    //     label={((params.row.status == 'Active') ? 'Deactivate ' : 'Activate ') + t("Customer")}
                    //     onClick={() => toggleCustomerStatus(params.id, params.row.status, params.row.route_id, params.row.community_user_id)}
                    //     showInMenu
                    // />,
                    // <GridActionsCellItem
                    //     label={t("Delete Customer")}
                    //     onClick={() => this.setState({showDeleteDialogue: true, deleteCustomerId: params.id})}
                    //     showInMenu
                    // />,

                ]
            }
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <NeighbourhoodHeader user={this.props.user} />
                {/* <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title="Overview"
                                className="text-left"
                            />
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex", boxShadow: 3 }}>
                                            <CardContent className='overview'>
                                                <Typography variant="h6" component="div" className='overviewTitle'>
                                                    Total Customers
                                                </Typography>
                                                <Typography variant="subtitle1" component="div" className='overviewValue'>
                                                    {this.state.customersTotalCount}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex", boxShadow: 3 }}>
                                            <CardContent className='overview'>
                                                <Typography variant="h6" component="div" className='overviewTitle'>
                                                    Active Registrations
                                                </Typography>
                                                <Typography variant="subtitle1" component="div" className='overviewValue statusTextSuccess'>
                                                    {this.state.customersActiveCount}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex", boxShadow: 3 }} component={Link} to={'/neighbourhood/inactive-registrations'}>
                                            <CardContent className='overview'>
                                                <Typography variant="h6" component="div" className='overviewTitle'>
                                                    Inactive Registrations
                                                </Typography>
                                                <Typography variant="subtitle1" component="div" className='overviewValue statusTextError'>
                                                    {this.state.customersInactiveCount}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid> */}
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card style={{ height: 600 }}>
                            <CardHeader
                                title={<>
                                    <Grid container spacing={2}>
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Customers List")}</Typography>
                                        </Grid>

                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.handleSearch())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                        {/* <Grid item md={2} xs={12}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel id="demo-simple-select-label">Type</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={this.state.type}
                                                    label="Age"
                                                    onChange={(e: any) => this.setState({ type: e.target.value }, () => this.fetchAllCustomers())}
                                                >
                                                    <MenuItem value='all'>All</MenuItem>
                                                    <MenuItem value='normal'>Normal</MenuItem>
                                                    <MenuItem value='community'>Community</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid> */}
                                        <Grid item md={4} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <Autocomplete
                                                    id="community-label"
                                                    freeSolo={false}
                                                    // options={this.state.routes}
                                                    options={this.state.routes.sort((a, b) => -b.type.localeCompare(a.type))}
                                                    groupBy={(community) => community.type}
                                                    getOptionLabel={(community) => community.name}
                                                    renderInput={(params: any) => <TextField {...params} label="Community" size="small" />}
                                                    onChange={(e: any, value: any) => this.setState({ filter_community: value }, () => this.fetchAllCustomers())}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </>
                                }
                                className="text-left"
                                action={
                                    <CardActions>
                                        <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddCustomer: true, customer_id: "", customer_name: "", mobile: "", email: "", city_id: "", customer_address: "", community_id: "", mrf: "", billing_amount: 0 })}>
                                            <Add /> Add Customer
                                        </Button>
                                        <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddBulkCustomer: true })}>
                                            <Add /> Add Bulk Customer
                                        </Button>
                                    </CardActions>
                                }
                            />

                            <CardContent>
                                <DataGrid
                                    aria-label="Customers List"
                                    columns={columns}
                                    rows={this.state.customers}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    page={this.state.currentPage}
                                    onPageChange={(page) => this.fetchAllCustomers(page)}
                                    // onPageChange={(newPage) => this.handlePageChange(newPage)}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize }, () => this.fetchAllCustomers(0, newPageSize))}
                                    
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    
                                    style={{ height: 500 }}
                                    pagination
                                    components={{
                                        
                                        MoreActionsIcon: EditOutlined,
                                        Pagination: () => (
                                            <CustomPagination
                                                count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                                                page={this.state.currentPage+1}
                                                onChange={(event, page) => this.fetchAllCustomers(page-1)}
                                              
                                            />
                                        )
                                    }}
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/neighbourhood/customers/' + params.id)
                                    }}
                                    paginationMode="server"
                                    className="clickableList"
                                />

                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showAddCustomer}
                    onClose={() => this.setState({ showAddCustomer: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={((this.state.customer_id) ? t("Edit") : t("Add")) + " " + t("Customer") + ((this.state.customer_name) ? ' of ' + this.state.customer_name : '')}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddCustomer: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="customer-name-input"
                                            label="Customer Name *"
                                            value={this.state.customer_name}
                                            onChange={(e: any) => this.setState({ customer_name: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="mobile-input"
                                            label="Mobile *"
                                            value={this.state.mobile}
                                            onChange={(e: any) => this.setState({ mobile: e.target.value })}
                                            fullWidth={true}
                                            disabled={!!this.state.customer_id}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="email-input"
                                            label="Email *"
                                            type={'email'}
                                            value={this.state.email}
                                            onChange={(e: any) => this.setState({ email: e.target.value })}
                                            fullWidth={true}
                                            disabled={!!this.state.customer_id}
                                        />
                                    </Grid>
                                    {
                                        !this.state.customer_id &&
                                        <Grid item md={4} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <InputLabel id="city-label">City *</InputLabel>
                                                <Select
                                                    labelId="city-label"
                                                    value={this.state.city_id}
                                                    onChange={(e) => this.setState({ city_id: e.target.value }, () => this.fetchRoutes([this.state.city_id]))}
                                                    displayEmpty
                                                    label="City *"
                                                    fullWidth={true}
                                                >
                                                    {
                                                        this.state.hierarchies.map((el: any, key: any) => {
                                                            return <MenuItem value={el.id} key={el.id}>{el.name}</MenuItem>
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    }
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="customer-address-input"
                                            label="Customer Address *"
                                            value={this.state.customer_address}
                                            onChange={(e: any) => this.setState({ customer_address: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    {
                                        !this.state.customer_id &&
                                        <Grid item md={4} xs={12}>
                                            <Autocomplete
                                                id="combo-box-demo"
                                                fullWidth={true}
                                                options={this.state.routes.sort((a, b) => -b.type.localeCompare(a.type))}
                                                groupBy={(community) => community.type}
                                                value={this.state.community_id?.id}
                                                onChange={(value: any, newValue: any) => this.setState({ community_id: newValue.id })}
                                                getOptionLabel={(options: any) => options.name}
                                                renderInput={(params) => <TextField {...params} label="Community" />}
                                            />

                                        </Grid>
                                    }
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddCustomer: false })}>Close</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.state.customer_id ? handleEditCustomer() : handleAddCustomer()}>{(this.state.customer_id ? "Edit" : "Add") + " Customer"}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showAddBulkCustomer}
                    onClose={() => this.setState({ showAddBulkCustomer: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("AddBulkCustomer")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddBulkCustomer: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <TextField id="outlined-basic" type={'file'} inputProps={{ accept: '.csv' }} label={t("File")} InputLabelProps={{ shrink: true }} onChange={(event: any) => handleFileChange(event.target.files[0])} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        {false && (<Autocomplete
                                            id="combo-box-demo"
                                            fullWidth={true}
                                            options={this.state.routes}
                                            value={this.state.community_id?.id}
                                            onChange={(value: any, newValue: any) => this.setState({ community_id: newValue.id })}
                                            getOptionLabel={(options: any) => options.name}
                                            renderInput={(params) => <TextField {...params} label="Community" />}
                                        />)}
                                    </Grid>
                                    <Grid item md={12} xs={12}>
                                        <Typography variant='body2'><span className='text-danger' style={{ fontWeight: '600' }}>Note: </span>{t("Please upload csv file only. Columns should be user_id, name, phone, email, house, is_active, priority respectively")}</Typography>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions>
                                <Grid container>
                                    <Grid item md={6} xs={12}>
                                        <Button size='small' variant='contained' className='link' href={'/samples/customers.csv'} download={true} color='info' sx={{ outline: 'none !important' }} onClick={() => console.log()}>{t("Download Sample CSV")}</Button>
                                    </Grid>
                                    <Grid item md={6} xs={12} className='text-right'>
                                        <Button size='small' className='customCloseButton' sx={{ marginRight: '8px' }} onClick={() => this.setState({ showAddBulkCustomer: false })}>{t("Close")}</Button>
                                        <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleAddBulkCustomer()}>{t("Submit")}</Button>
                                    </Grid>
                                </Grid>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                {/* <Dialog
                    open={this.state.showDeleteDialogue}
                    onClose={() => this.setState({ showDeleteDialogue: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to delete this customer ?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showDeleteDialogue: false })}>{t("Cancel")}</Button>
                        <Button onClick={() => handleDeleteCustomer(this.state.deleteCustomerId)} autoFocus>{t("Ok")}</Button>
                    </DialogActions>   
                </Dialog> */}
            </div>
        )
    }
}

export default withRouter(withTranslation()(CustomersList))
